import React, { createContext, useReducer } from 'react';

type State = {
  conversion: Record<string, boolean | undefined>;
};

export enum ConversionActions {
  InitializeProfiles = 'initializeProfiles',
  SwitchProfile = 'switchProfile',
  UpdateProfiles = 'updateProfiles',
  SetFlags = 'setFlags',
  Erase = 'erase',
  AuthenticateUser = 'authenticateUser',
  ToggleConversion = 'toggleConversion',
  ValidateUserConversion = 'validateUserConversion',
  DeleteUserConversion = 'deleteUserConversion',
  SetProfileStatus = 'setProfileStatus',
}

type Payload = {
  [ConversionActions.ToggleConversion]: { toggleType: string };
};

const initialState: State = {
  conversion: {},
};

function reducer(state: State, action: Action<Payload>): State {
  switch (action.type) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    case ConversionActions.ToggleConversion:
      return {
        ...state,
        conversion: {
          ...state.conversion,
          [action.toggleType]: !state.conversion[action.toggleType],
        },
      };
    default:
      throw new Error('Conversion reducer case not found');
  }
}

export const ConversionContext = createContext<{
  state: State;
  dispatch: React.Dispatch<Action<Payload>>;
}>({ state: initialState, dispatch: () => null });

export function ConversionProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = React.useMemo(() => ({ state, dispatch }), [state]);

  return (
    <ConversionContext.Provider value={value}>
      {children}
    </ConversionContext.Provider>
  );
}
